<template>
  <div>
    <header class="navigation">
      <div class="navigation-wrapper">


        
        <nav class="navigation-split-left nav">
          <ul>
            <router-link to="/front" class="text-dark">
              <img src="/public/images/logo-wide.svg" class="logo" alt="Coop Finance" />
            </router-link>
            <li>
              <a href="">Coop</a>
            </li>
            <li>
              <a class="active" href="">Carte</a>
            </li>
            <li>
              <router-link to="/front/aide">Aide</router-link>
            </li>
          </ul>
        </nav>

        <nav class="navigation-split-right nav">
          <ul class="justify-content-end">
            <!-- Utilisateur connecté -->
            <li class="mr-2">
                <!-- <a href="">Market </a> -->
                <router-link class="tag-state lg rounded-50 flex align-items-center gap-2 px-5 py-3" to="/front/market/panier" style="height: auto">
                      <img src="/public/icons/icon-panier.svg" class="size-medium" alt="" />
                      <h6 class="secondary-font mt-1">Achat ({{ getTotalItems }})</h6>
                      <div class="my-badge br2 dot bg-color-1000"></div>
                </router-link>
            </li>
            <li>
              <a @click="handleLogout" class="active border-transparent" style="cursor: pointer;">
                Déconnexion <img src="/public/icons/icon-logout.svg" class="nav-icon" alt="" /> 
              </a>
            </li>
            <li>
              <router-link to="/front/profil" class="active border-transparent">
                <img v-if="userAvatar" :src="userAvatar" class="size-base rounded-100 mr-4" alt="" />
                <img v-else src="/public/icons/icon-profil.svg" class="size-base rounded-100 mr-4" alt="" />
                <p>
                  {{ userName || 'Mon compte' }} <br/>
                  <span class="font-normal text-xs">Mon compte</span>
                </p>
                <img src="/public/icons/icon-go.svg" class="nav-icon" alt="" /> 
              </router-link>
            </li>
          </ul>
        </nav>

        <div class="navigation-main">
          <h1 class="mb-2">Coop Finance</h1>
          <p class="">Votre partenaire de confiance pour les solutions financières</p>
        </div>
        
        <!-- Menu frontoffice -->
        <nav class="navigation-bottom nav2">
          <ul>
            <li v-if="isGerant">
              <router-link to="/front/collectivites">
                <img src="/public/icons/icon-collectivite.svg" class="nav2-icon" alt="" /> Collectivités
              </router-link>
            </li>
            <li>
              <router-link to="/front/wallet">
                <img src="/public/icons/icon-wallet.svg" class="nav2-icon" alt="" /> Wallet
              </router-link>
            </li>
            <li>
              <router-link to="/front/market/portail">
                <img src="/public/icons/icon-market.svg" class="nav2-icon" alt="" /> Market
              </router-link>
            </li>
            <li>
              <router-link to="/front/ma-carte">
                <img src="/public/icons/icon-carte.svg" class="nav2-icon" alt="" /> Ma Carte
              </router-link>
            </li>
            <li>
              <router-link to="/front/budget">
                <img src="/public/icons/icon-budget.svg" class="nav2-icon" alt="" /> Budget
              </router-link>
            </li>
            <li>
              <router-link to="/front/profil">
                <img src="/public/icons/icon-profil.svg" class="nav2-icon" alt="" /> Mon profil
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </header>

    <main>
     
          <router-view />
    </main>

    <footer>
      <p>&copy; 2024 Coop Finance. Tous droits réservés.</p>
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import authService from '@/services/authService'
import { useMarketCartStore } from '@/stores/cart.store';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'AuthenticatedLayout',
  setup() {
    const router = useRouter()
    const userName = ref<string>('')
    const userAvatar = ref<string>('')
    const userData = ref<any>(null)
    const cartStore = useMarketCartStore();
    const { getTotalItems } = storeToRefs(cartStore);

    const isGerant = computed(() => {
      if (!userData.value) return false

      // Utiliser le nouveau champ is_gerant (production-ready)
      // Fallback sur fonction pour compatibilité avec l'ancien système
      if (userData.value.is_gerant !== undefined) {
        return userData.value.is_gerant === true
      }

      // Fallback: Vérifier si l'utilisateur est gérant via le champ fonction (ancien système)
      const fonction = userData.value.fonction || ''
      return fonction && fonction.toLowerCase() === 'gérant'
    })

    onMounted(() => {
      // Récupérer les infos utilisateur du localStorage via authService
      const currentUser = authService.getCurrentUser()
      if (currentUser) {
        userData.value = currentUser
        userName.value = currentUser.nom || currentUser.prenom || ''
        userAvatar.value = currentUser.avatar || currentUser.photo || ''

        console.log('[AuthenticatedLayout] Utilisateur chargé:', {
          nom: currentUser.nom,
          fonction: currentUser.fonction,
          is_gerant: currentUser.is_gerant,
          isGerantComputed: isGerant.value
        })
      } else {
        console.warn('[AuthenticatedLayout] Aucun utilisateur trouvé dans le localStorage')
      }
    })

    const handleLogout = async () => {
      try {
        await authService.logout()
        
        // Nettoyer le stockage local
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('userEmail')
        sessionStorage.clear()
        
        // Rediriger vers la page de connexion
        router.push('/auth/sign-in')
      } catch (error) {
        console.error('Erreur lors de la déconnexion:', error)
        // Même en cas d'erreur, on déconnecte côté client
        localStorage.clear()
        sessionStorage.clear()
        router.push('/auth/sign-in')
      }
    }

    return {
      userName,
      userAvatar,
      isGerant,
      handleLogout,
      getTotalItems
    }
  }
})
</script>

<style scoped>
/* Styles spécifiques pour les liens actifs Vue Router */
.nav2 li a.router-link-active {
  color: rgb(var(--color-white-rgb), 1) !important;
  background-color: rgb(var(--primary-color-rgb), 0.7);
  border-radius: 20px;
  border: 2px solid rgb(var(--primary-color-rgb), 0.3);
  box-shadow: 0 0 0 0.35rem rgb(var(--component-color-rgb), 0.15);
}

.nav2 li a.router-link-active .nav2-icon {
  filter: brightness(0) invert(100%) !important;
}

/* Footer */
footer {
  padding: 1rem;
  text-align: center;
  margin-top: 2rem;
}
</style>

